import { render, staticRenderFns } from "./kartuangsuran.vue?vue&type=template&id=5717b0e2&scoped=true&"
import script from "./kartuangsuran.vue?vue&type=script&lang=js&"
export * from "./kartuangsuran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5717b0e2",
  null
  
)

export default component.exports